module.exports = new __parcel__URL__("lock_closed.80a15025.svg").toString();